import React from "react";

function Data_Warehouse() {
  return (
    <div className="courseData">
      <div className="container">
        <div className="row">
          <div className="course_details_heading">
            <h1>RHCSA</h1>
          </div>
          <div className="imgSection">
            <img
              src={require("../../../images/courses/rhcsa-img-500x262.png")}
              alt=""
            />
          </div>
          <div className="heading">
            <h3>RHCSA – RED HAT CERTIFIED SYSTEM ADMINISTRATION </h3>
            <p>
              RHCSA – Red Hat Certified System Administration is reputed lab
              based exam conducted by Red Hat. Focus Training services is an
              authorized training partner who conducts authorised Training and
              Certification program for RHCSA (SAI & SAII ) in Pune, India.
              SYSTEM ADMINISTRATION I& II (RH 124 & 134)
            </p>

            <h4>SKILLSET AFTER EARNING THE CERTIFICATION RHCSA </h4>
            <ul>
              <li>
                Understand and use essential tools for handling files,
                directories, command-line environments, and documentation{" "}
              </li>
              <li>
                {" "}
                Operate running systems, including booting into different run
                levels, identifying processes, starting and stopping virtual
                machines, and controlling services
              </li>
              <li>
                {" "}
                Configure local storage using partitions and logical volumes
              </li>
              <li>
                Create and configure file systems and file system attributes,
                such as permissions, encryption, access control lists, and
                network file systems{" "}
              </li>
              <li>
                Deploy, configure, and maintain systems, including software
                installation, update, and core services{" "}
              </li>
              <li>
                Manage users and groups, including use of a centralized
                directory for authentication{" "}
              </li>
              <li>
                {" "}
                Manage security, including basic firewall and SELinux
                configuration
              </li>
            </ul>
            {/*  */}
            <h4>
            ELIGIBILITY for RHCSA 
            </h4>
            <ul>
              <li>Experienced Red Hat Enterprise Linux system administrators seeking validation of their skills </li>
              <li>Students who have attended Red Hat System Administration I and II and are on the path to earn RHCSA certification </li>
              <li>Experienced Linux system administrators who require a certification either by their organization or based on a mandate (DOD 8570 directive) </li>
              <li>IT professionals who are on the path to earn a Red Hat Certified Engineer (RHCE®) certification </li>
              <li>RHCEs who are non-current or who are about to become non-current and wish to re-certify as RHCEs </li>
            </ul>
            {/*  */}

            <h4>
            EXAM CODE For RHCSA 
            </h4>
            <h6>
            EX200 – Red Hat Certified System Administration (RHCSA) exam
            </h6>

            <h3>COURSE CONTENT For RHCSA</h3>

              <h4 style={{color: "blue"}} >
              RED HAT SYSTEM ADMINISTRATION I (RH124)
              </h4>
{/*  */}
              <h4>
              ACCESS THE COMMAND LINE
              </h4>
              <ul>
                <li>
                Log in to a Linux system and run simple commands using the shel
                </li>
              </ul>

              {/*  */}

              {/*  */}
              <h4>
              MANAGE FILES FROM THE COMMAND LINE
              </h4>
              <ul>
                <li>
                Copy, move, create, delete, and organize files from the bash shell prompt.
                </li>
              </ul>

              {/*  */}

              {/*  */}
              <h4>
              GETTING HELP IN RED HAT ENTERPRISE LINUX
              </h4>
              <ul>
                <li>
                Resolve problems by using online help systems and Red Hat support utilities.
                </li>
              </ul>

              {/*  */}



              {/*  */}
              <h4>
              CREATE, VIEW, AND EDIT TEXT FILES
              </h4>
              <ul>
                <li>
                Create, view, and edit text files from command output or in an editor.
                </li>
              </ul>

              {/*  */}


              {/*  */}
              <h4>
              MANAGE LOCAL LINUX USERS AND GROUPS
              </h4>
              <ul>
                <li>
                Manage local Linux users and groups, and administer local password policies.
                </li>
              </ul>

              {/*  */}

              {/*  */}
              <h4>
              CONTROL ACCESS TO FILES WITH LINUX FILE SYSTEM PERMISSIONS
              </h4>
              <ul>
                <li>
                Set Linux file system permissions on files and interpret the security effects of different permission settings.
                </li>
              </ul>

              {/*  */}

              {/*  */}
              <h4>
              MONITOR AND MANAGE LINUX PROCESSES
              </h4>
              <ul>
                <li>
                Obtain information about the system, and control processes running on it.
                </li>
              </ul>

              {/*  */}


              {/*  */}
              <h4>
              CONTROL SERVICES AND DAEMONS
              </h4>
              <ul>
                <li>
                Control and monitor network services and system daemons using systemd.
                </li>
              </ul>

              {/*  */}

              {/*  */}

              <h4>
              CONFIGURE AND SECURE OPENSSH SERVICE
              </h4>
              <ul>
                <li>
                Access and provide access to the command line on remote systems securely using OpenSSH.
                </li>
              </ul>

              {/*  */}


              <h4>
              ANALYZE AND STORE LOGS
              </h4>
              <ul>
                <li>
                Locate and accurately interpret relevant system log files for troubleshooting purposes.
                </li>
              </ul>

              {/*  */}


              <h4>
              MANAGE RED HAT ENTERPRISE LINUX NETWORKING
              </h4>
              <ul>
                <li>
                Configure basic IPv4 networking on Red Hat Enterprise Linux systems.
                </li>
              </ul>

              {/*  */}


              <h4>
              ARCHIVE AND COPY FILES BETWEEN SYSTEMS
              </h4>
              <ul>
                <li>
                Archive files and copy them from one system to another.
                </li>
              </ul>

              {/*  */}


              <h4>
              INSTALL AND UPDATE SOFTWARE PACKAGES
              </h4>
              <ul>
                <li>
                Download, install, update, and manage software packages from Red Hat and yum package repositories
                </li>
              </ul>

              {/*  */}


              <h4>
              ACCESS LINUX FILE SYSTEMS
              </h4>
              <ul>
                <li>
                Access and inspect existing file systems on a Red Hat Enterprise Linux system.
                </li>
              </ul>

              {/*  */}


              <h4>
              USE VIRTUALIZED SYSTEMS
              </h4>
              <ul>
                <li>
                Create and use Red Hat Enterprise Linux virtual machines with KVM and libvirt.
                </li>
              </ul>

              {/*  */}


              <h4>
              COMPREHENSIVE REVIEW
              </h4>
              <ul>
                <li>
                Practice and demonstrate the knowledge and skills learned in this course
                </li>
              </ul>

              {/*  */}

              <h4 style={{color: "blue"}} >
              RED HAT SYSTEM ADMINISTRATION I (RH124)
              </h4>
              <h4>
              AUTOMATE INSTALLATION WITH KICKSTART
              </h4>
              <ul>
                <li>
                Automate the installation of Red Hat Enterprise Linux systems with Kick start.
                </li>
              </ul>

              {/*  */}


              <h4>
              USE REGULAR EXPRESSIONS WITH GREP
              </h4>
              <ul>
                <li>
                Write regular expressions that, when partnered with grep, will allow you to quickly isolate or locate Content within text files.
                </li>
              </ul>

              {/*  */}


              <h4>
              CREATE AND EDIT TEXT FILES WITH VIM
              </h4>
              <ul>
                <li>
                Introduce the vim text editor, with which you can open, edit, and save text files.
                </li>
              </ul>

              {/*  */}


              <h4>
              SCHEDULE FUTURE LINUX TASKS
              </h4>
              <ul>
                <li>
                Schedule tasks to automatically execute in the future.
                </li>
              </ul>

              {/*  */}


              <h4>
              MANAGE PRIORITY OF LINUX PROCESSES
              </h4>
              <ul>
                <li>
                Influence the relative priorities at which Linux processes run.
                </li>
              </ul>

              {/*  */}


              <h4>
              CONTROL ACCESS TO FILES WITH ACCESS CONTROL LISTS (ACL)
              </h4>
              <ul>
                <li>
                Manage file security using POSIX access control list
                </li>
              </ul>

              {/*  */}


              <h4>
              MANAGE SELINUX SECURITY
              </h4>
              <ul>
                <li>
                Manage the Security Enhanced Linux (SELinux) behavior of a system to keep it secure in case of a network service compromise.
                </li>
              </ul>

              {/*  */}


              <h4>
              CONNECT TO NETWORK-DEFINED USERS AND GROUPS
              </h4>
              <ul>
                <li>
                Configure systems to use central identity management services.
                </li>
              </ul>

              {/*  */}


              <h4>
              CONFIGURE AND SECURE OPENSSH SERVICE
              </h4>
              <ul>
                <li>
                Access and provide access to the command line on remote systems securely using OpenSSH.
                </li>
              </ul>

              {/*  */}


              <h4>
              ADD DISKS, PARTITIONS, AND FILE SYSTEMS TO A LINUX SYSTEM
              </h4>
              <ul>
                <li>
                Manage simple partitions and file systems.
                </li>
              </ul>

              {/*  */}


              <h4>
              CONFIGURE AND SECURE OPENSSH SERVICE
              </h4>
              <ul>
                <li>
                Access and provide access to the command line on remote systems securely using OpenSSH.
                </li>
              </ul>

              {/*  */}


              <h4>
              MANAGE LOGICAL VOLUME MANAGEMENT (LVM) STORAGE
              </h4>
              <ul>
                <li>
                Manage logical volumes from the command line.
                </li>
              </ul>

              {/*  */}

              <h4>
              MACCESS NETWORKED ATTACHED STORAGE WITH NETWORK FILE SYSTEM (NFS)
              </h4>
              <ul>
                <li>
                Access (secure) NFS shares.
                </li>
              </ul>

              {/*  */}

              <h4>
              ACCESS NETWORKED STORAGE WITH SMB
              </h4>
              <ul>
                <li>
                Use autofs and the command line to mount and unmount SMB file systems.
                </li>
              </ul>

              {/*  */}

              <h4>
              MANAGE LOGICAL VOLUME MANAGEMENT (LVM) STORAGE
              </h4>
              <ul>
                <li>
                Manage logical volumes from the command line.
                </li>
              </ul>

              {/*  */}

              <h4>
              CONTROL AND TROUBLESHOOT THE RED HAT ENTERPRISE LINUX BOOT PROCESS LIMIT NETWORK COMMUNICATION WITH FIREWALL
              </h4>
              <ul>
                <li>
                Configure a basic firewall.
                </li>
              </ul>

             
             

          </div>
        </div>
      </div>
    </div>
  );
}

export default Data_Warehouse;
